module.exports = __webpack_public_path__ + "img/osv-example.ac244ef9.jpg";